import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import { Subsection } from 'src/app/models/subsection';
import * as subsectionActions from './subsections.actions';

export interface SubsectionState extends EntityState<Subsection> {
  selectedSubsection: Subsection;
}

export const subsectionAdapter: EntityAdapter<Subsection> = createEntityAdapter<Subsection>({});

export const initialSubsectionState: SubsectionState = subsectionAdapter.getInitialState({
  selectedSubsection: null,
});

export const reducer = createReducer(
  initialSubsectionState,
  on(subsectionActions.getSubsections, (state, { subsections }) => {
    return subsectionAdapter.setAll(subsections, {
      ...state,
    });
  }),
  on(subsectionActions.setSelectedSubsection, (state, { selectedSubsection }) => {
    return {
      ...state,
      selectedSubsection,
    };
  }),
  on(subsectionActions.createSubsectionSuccess, (state, { createdSubsection }) => {
    return subsectionAdapter.addOne(createdSubsection, {
      ...state,
      selectedSubsection: null,
    });
  }),
  on(subsectionActions.updateSubsectionSuccess, (state, { updatedSubsection }) => {
    return subsectionAdapter.updateOne(
      { id: updatedSubsection?.id, changes: updatedSubsection },
      {
        ...state,
        selectedSubsection: null,
      }
    );
  }),
  on(subsectionActions.deleteSubsectionSuccess, (state, { deletedSubsection }) => {
    return subsectionAdapter.removeOne(deletedSubsection.id, {
      ...state,
      selectedSubsection: null,
    });
  })
);

export function SubsectionReducer(state: SubsectionState | undefined, action: Action) {
  return reducer(state, action);
}

export const { selectIds, selectEntities, selectAll, selectTotal } = subsectionAdapter.getSelectors();
